import { render, staticRenderFns } from "./BonusLargeIcon.vue?vue&type=template&id=093391aa&"
import script from "./BonusLargeIcon.vue?vue&type=script&lang=ts&"
export * from "./BonusLargeIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports